import { MessageObserverInterface } from "./messageObserverInterface";
import { MessageDetailType } from "../messageBuilder";
import { CHARACTER_LIMIT } from "../../../constants/globals";
import { MessageFacade } from "../messageFacade";
import { generateRandomId } from "../../utils";
import { RoomMessageType } from "../../../proto/Global_pb";

export class LargeTextObserverObserver implements MessageObserverInterface {
  constructor(protected messageDetail: MessageDetailType) {}
  handle(from = CHARACTER_LIMIT, to = CHARACTER_LIMIT + CHARACTER_LIMIT): void {
    let messageTemp = this.messageDetail.message.message.slice(from, to);
    if (!messageTemp) return;
    from += CHARACTER_LIMIT;
    to += CHARACTER_LIMIT;
    new MessageFacade({
      ...this.messageDetail,
      message: {
        ...this.messageDetail.message,
        randomId: generateRandomId(),
        message: messageTemp,
        messageType: RoomMessageType.TEXT,
      },
    })
      .handle()
      .then();
    setTimeout(() => {
      this.handle(from, to);
    }, 1000);
  }
}
